import {useCallback, useEffect} from "react";
import { useContextSelector } from "use-context-selector";
import { AppDatesContext, AppNotificationsDrawerContext } from "app/providers";
import { useToaster } from "ui-seeker/core";
import { postSubmit } from "ui-seeker/utils";
import { ALERTS } from "app/@common/constants";

export default function useAppNotificationsDrawer() {
    const isOpenAlertsDrawer = useContextSelector(AppNotificationsDrawerContext, ({ state }) => state.isOpenAlertsDrawer)
    const totalAlertsNotifications = useContextSelector(AppNotificationsDrawerContext, ({ state }) => state.totalAlertsNotifications)
    const updateNotifications = useContextSelector(AppNotificationsDrawerContext, ({ updateState }) => updateState);
    const monthYear = useContextSelector(AppDatesContext, ({state}) => state.monthYear)
    const { showToaster } = useToaster()


    const getTotalAlertsNotifications = monthYear => {
        updateNotifications({ isLoading: true })
        postSubmit(ALERTS.COUNT, { dateRange: monthYear }).then(data => {
            updateNotifications({totalAlertsNotifications: data, isLoading: false})
        }).catch(res => {
            showToaster.error(res.statusText)
            updateNotifications({isLoading: false})
        })
    }

    const setOpenDrawer = useCallback(() => {
        updateNotifications({ isOpenAlertsDrawer: !isOpenAlertsDrawer })
    }, [ isOpenAlertsDrawer, updateNotifications])

    useEffect(() => {
        if (!!monthYear && monthYear !== 'custom') {
            getTotalAlertsNotifications(monthYear)
        }
        // eslint-disable-next-line
    }, [monthYear])


    return {
        isOpenAlertsDrawer,
        totalAlertsNotifications,
        setOpenDrawer
    }
}